import { Injectable } from "@angular/core";
import { GridLayoutService } from "@irb/irb-common/interfaces/grid-layout.service";
import { ComPortfolioNotesComponent } from "./com-portfolio-notes.component";
import { AltSecDropDownCellEditor } from "../com-alt-securities-dropdown/com-alt-securities-dropdown-editor.component";
import { AltSecDropDownCellRenderer } from "../com-alt-securities-dropdown/com-alt-securities-dropdown-renderer.component";
import { DeleteHeaderComponent } from "@irb/irb-common/components/grid/renderers/delete.header.component";
import { DeleteCellComponent } from "@irb/irb-common/components/grid/renderers/delete.cell.component";
import { formatDate } from "@angular/common";
import { TruncateTooltipCellComponent } from "@irb/irb-common/components/grid/renderers/truncatetooltip.cell.component";
import { ArchiveCellComponent } from "@irb/irb-common/components/grid/renderers/archive.cell.component";
import { IDropdownItem } from "@irb/irb-common/models/dropdown.model";
import { DropdownFilterRendererComponent } from "@irb/irb-common/components/grid/renderers/dropdown-filter.cell.component";

@Injectable({
  providedIn: "root",
})
export class ComPortfolioNotesGridLayoutService implements GridLayoutService<ComPortfolioNotesComponent> {
  sizeFor: any;
  //['High','Medium','Normal']

  priorityType: IDropdownItem = { value: "Medium", name: "Medium" };
  priorityTypes: Array<IDropdownItem> = [
    { value: "High", name: "High" },
    { value: "Medium", name: "Medium" },
    { value: "Normal", name: "Normal" },
  ];
  constructor() {
  }

  getFrameworkComponents() {
    return {
      AltSecDropDownCellEditor: AltSecDropDownCellEditor,
      AltSecDropDownCellRenderer: AltSecDropDownCellRenderer,
      ArchiveCellComponent: ArchiveCellComponent,
      TruncateTooltipCellComponent: TruncateTooltipCellComponent,
      DeleteHeaderComponent: DeleteHeaderComponent,
      DeleteCellComponent: DeleteCellComponent,
      DropdownFilterRendererComponent: DropdownFilterRendererComponent,
    };
  }

  statusDisplayValue(params: any) {
    if (params.data.isArchive) {
      return "Archived";
    } else {
      return "Active";
    }
  }

  formatCreatedDate(params: any) {
    return formatDate(params.data.modifiedDate, "MM/dd/yyyy h:mm a", "en-US", "EST")  + " " + "ET";
  }

  getColumnDefs(parent: ComPortfolioNotesComponent) {
    return [
      {
        headerName: "Delete All",
        headerComponent: "DeleteHeaderComponent",
        headerComponentParams: {
          message: "Delete ALL current Notes from the portfolio?",
          proceed: parent.deleteAll.bind(parent),
          cancel: parent.cancelDelete.bind(parent),
          hide: parent.removeDeleteColumn.bind(parent),
        },
        cellRenderer: "DeleteCellComponent",
        // editable: this.canEdit.bind(this),
        cellRendererParams: {
          message: "Delete this note?",
          proceed: parent.delete.bind(parent),
          cancel: parent.cancelDelete.bind(parent),
          hide: parent.removeDeleteColumn.bind(parent),
          
        },
        resizable: false,
        minWidth: 25,
        maxWidth: 25,
        width: 25,
        pinned: "left",
        lockPosition: true
      },
      {
        headerName: "Status",
        field: "status",
        headerComponentParams: {
          irbColInfo: this.StatusToolTipColInfo()
        },
        valueGetter: this.statusDisplayValue,
        sort: "asc",
        //tooltipField: this.statusToolTipValue,
        //comparator: this.util.sortString.bind(parent),
        flex: 1
      },
      {
        headerName: "Date Last Edited",
        field: "modifiedDate",
        cellRenderer: 'cellRendererFormatter',
        cellRendererParams: {type: 'date', format: 'MM/dd/yyyy h:mm a', displayETtext: true},
        suppressFiltersToolPanel: true,
        sort: "desc",
        //comparator: this.util.sortString.bind(parent),
        flex: 1
      },
      {
        headerName: "By",
        field: "modifiedBy",
        flex: 1
      },
      {
        headerName: "Note",
        field: "comment",
        valueSetter: function (params: any) {
          params.data.comment = params.newValue;
          parent.change.emit(true); //parent.gridChangeEvent();
          return true;
        }.bind(parent),
        cellRenderer: "cellRendererFormatter",
        onCellClicked: (params: any)=>{
          if(!params.data.isArchive) {
            if (params.context)
              params.context.currentNoteId = params.data.noteId || params.data.comment;
            parent.editNote(params);
            let p = {
              force: true,
              suppressFlash: false,
              columns: [params.column],
            };
            if (parent.grid && parent.grid.api)
              parent.grid.api.refreshCells(p);
          }
        },
        cellRendererParams: "TruncateTooltipCellComponent",
        cellStyle: (params: any) => {
          const v: any = params.data.noteId || params.data.comment;
          if (params.context && params.context.currentNoteId === v) {
            return {borderColor: '#0091ea'};
          } else {
            return {borderColor: ''};
          }
        },
        flex: 3
      },
      {
        headerName: "Priority",
        field: "priority",
        cellClass: "dropdownFilterCell",
        cellRenderer: "DropdownFilterRendererComponent",
        cellRendererParams: (params: any) => {
          return {
            defaultValue: { name: params.data.priority, value: params.data.priority },
            values: this.priorityTypes,
            hoverPanelWidth: 180,
            disabled: params.data.isArchive,
            onChange: (params: any, item: IDropdownItem) => {
              params.data.priority = item.name;
              params.data.isNoteEdited = true;
              params.api.redrawRows({rowNodes: [params.node]});
              parent.change.emit(true);
            },
          };
        },
        flex: 1
      },
      {
        headerName: "",
        field: "",
        valueGetter: this.statusDisplayValue.bind(this),
        cellRenderer: "ArchiveCellComponent",
        sortable: false,
        flex: 1
      },
    ];
  }

  canEdit(params: any) {
    if (params.column.colId === "status") {
      return false;
    }
  }

  StatusToolTipColInfo(){
    return `
      <div>
      Notes must be active to edit or delete. An archived note can be edited or deleted by using the Activate button to change its status.
            </div>
            
      `
}
}
